import { useRouter } from 'next/router';

const TelemedicineDoctorListEmpty = () => {
  const router = useRouter();

  const handleBackClick = () => {
    router.back();
  };

  return (
    <div className='flex h-full min-h-[492px] w-full flex-col items-center justify-center gap-[24px] px-[24px] pb-[80px]'>
      <div className='flex w-full shrink-0 flex-col gap-[8px] text-center'>
        <div className='typography-ui-17sb w-full text-gray-900'>예약 가능한 의사가 없어요</div>
        <div className='typography-ui-13r w-full text-gray-400'>
          선호 의사 조건을 변경하거나, 진료 시간을 변경해보세요.
        </div>
      </div>
      <button
        onClick={handleBackClick}
        className='flex h-[32px] shrink-0 items-center justify-center gap-[4px] rounded-[8px] border border-gray-100 border-solid bg-white px-[8px]'
      >
        <span className='typography-ui-13m whitespace-pre text-gray-600'>선호 조건 변경</span>
      </button>
    </div>
  );
};

export default TelemedicineDoctorListEmpty;
